/**
 * useCommerceChannels
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import CommerceChannelsContext from './commerce-channels-context'

const useCommerceChannels = () => {
  const context = useContext(CommerceChannelsContext)
  return context
}

export default useCommerceChannels
